import ProfileDetailUserDataSubAccounts from './profileDetailUserDataSubAccounts';
import ProfileDetailUserData from './ProfileDetailUserData';
import { IUserData } from '@/lib/interface';

export type TTabname = 'photos' | 'transactions' | 'subAccounts' | 'payments' | 'pushes';

export type TProps = {
  userData: IUserData;
};

export default ProfileDetailUserData;

export {
  ProfileDetailUserDataSubAccounts
};
